import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCategoryLargeFormat';
/** Renders an SVG icon. */
const SvgCategoryLargeFormat = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3 8a3 3 0 0 1 3-3h20a3 3 0 0 1 3 3v16a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2v-5h-4a1 1 0 1 1 0-2h4V8a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v9h4a1 1 0 1 1 0 2H5v5a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2zm4 2a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6 14a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2h-1v11a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V15H7a1 1 0 0 1-1-1m4 1v11h12V15z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.385 18.503a.75.75 0 0 1-.064 1.058L13.13 21.5l2.19 1.939a.75.75 0 0 1-.995 1.122l-2.823-2.5a.75.75 0 0 1 0-1.122l2.823-2.5a.75.75 0 0 1 1.06.064m2.585.967a.75.75 0 0 1 1.06 0l1.5 1.5a.75.75 0 0 1 0 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06l.97-.97-.97-.97a.75.75 0 0 1 0-1.06"
      />
      <path
        fill="currentColor"
        d="m16.604 22.646.792-.792a.5.5 0 0 0 0-.708l-.792-.792a.5.5 0 0 0-.708 0l-.792.792a.5.5 0 0 0 0 .708l.792.792a.5.5 0 0 0 .708 0M22 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
      />
    </svg>
  );
};
SvgCategoryLargeFormat.displayName = displayName;
export default SvgCategoryLargeFormat;
